<template>
  <div class="about-box">
<!--    <div class="about-title-box">-->
<!--      <span></span>特资信简介-->
<!--    </div>-->
    <div class="plant-about-info-box">
      <div style="text-align: center;margin: 10px;">
        <h2>特资信大模型简介</h2>
      </div>
      <p>特资信大模型•特殊资产价值智评系统。以数据+技术破局，让特殊资产价值穿透迷雾、一目了然。</p>
      <p>
        特殊资产，指非标准化、非流动性资产，如不良债权、涉诉资产、违约债券、重组资产、企业应收账款、商账抵款资产等，具有个体特质强、市场操作性差、不确定性高的特点。资产特性、市场环境、监管政策三重因素交织，传统评估方式难以穿透表象触及本质。特殊资产价值评定是金融领域的“世界性难题”。
      </p>
      <p>
        特资信大模型，创新构建“多元数据+AI+区块链+多模态”四维驱动体系，实现对特殊资产的深度价值挖掘与风险量化。大模型通过采集债务人财务与非财务数据、信用记录、抵押物状态、担保保证、法律诉讼、行政监管、债权特性、历史交易、行业发展等千余类维度大数据，构建全景数据网络。依托决策树、随机森林、神经网络等先进大模型算法，开展“定性+定量”双维度分析，自动识别资产风险特征，量化潜在损失风险，形成科学决策依据。特资信大模型对债务人进行精准风险等级画像，动态预测资产收购价值与回收率，为资产处置、投资决策或监管行动提供依据。
      </p>
      <p>在风险等级划分上，特资信大模型建立动态量化标准体系，将风险等级从高到低划分为A、B、C、D四级，<b>A级</b>(可能回收率80%以上)，<b>B级</b>（可能回收率50%-80%)，<b>C级</b>(可能回收率20%-50%)，<b>D级</b>（可能回收率低于20%)。风险等级反映资产当前价值，根据动态数据捕捉市场环境与政策法规变化带来的价值波动，实现风险评估的科学性与前瞻性统一。特资信大模型，以技术穿透复杂，以数据定义价值，让特殊资产从“模糊估价”走向“精准定价”，为特殊资产处置与投资注入确定性。 </p>
      <p>特资信大模型，让特殊资产价值一目了然。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>

</style>
